import { create } from 'zustand';

// eslint-disable-next-line import/prefer-default-export
export const useTemplateListingStore = create(setState => ({
  search: '',
  setSearch: search => setState({ search }),
  categoryId: null,
  setCategoryId: categoryId => setState({ categoryId }),
  emailTypeId: null,
  setEmailTypeId: emailTypeId => setState({ emailTypeId }),
  onlyActive: true,
  setOnlyActive: onlyActive => setState({ onlyActive }),
  onlyAmp: false,
  setOnlyAmp: onlyAmp => setState({ onlyAmp }),
  page: 1,
  setPage: page => setState({ page }),
  pageSize: 15,
  setPageSize: pageSize => setState({ pageSize }),
  sortColumn: {},
  setSortColumn: (accessor: string) =>
    setState(({ sortColumn }) => {
      if (sortColumn.name !== accessor)
        return { sortColumn: { name: accessor, desc: true } };
      if (!sortColumn.desc) return { sortColumn: {} };
      return { sortColumn: { name: accessor, desc: false } };
    }),
}));
